import * as React from "react";
import { forwardRef } from "react";
const SvgCaretUp = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" ref={ref} {...props}><path fill="currentColor" d="M7.299 5.27c.368-.36 1.034-.36 1.402 0l4.187 4.091c.257.251.044.639-.35.639H3.462c-.395 0-.608-.388-.35-.639l4.186-4.09z" /></svg>;
const ForwardRef = forwardRef(SvgCaretUp);
export default ForwardRef;